<template lang="html">
  <div>
    <div class="table-card pl-box-shadow">
      <div class="table-card-title mb3 center-xs middle-xs flex">
        <span class="mr3">{{ title }}</span>
        <i
          v-my-tooltip.left="tooltip"
          class="fa fa-info-circle"
          style="color: #848484; font-size: 14px"
          aria-hidden="true"
        />
      </div>
      <div
        v-if="tableKey === 'activeTeacher'"
        class="table-data overflow-auto start-xs"
      >
        <div
          class="row w-100 no-margin pb3"
          v-for="(teacher, index) in analyticsMostActiveTeachers"
          :key="teacher.id"
        >
          <div class="row col-xs-9 no-padding ellipsis">
            <span class="col-xs-2 w-100 tl" style="padding-right: 0"
              >{{ index + 1 }}.</span
            >
            <span
              class="col-xs-10 no-padding table-data-name clickable"
              @click="openUserDetails(teacher)"
            >
              {{ teacher.name }}
            </span>
          </div>
          <div class="col-xs-3 no-padding ellipsis end-xs">
            {{ teacher.rts_count }} RTs
          </div>
        </div>
      </div>
      <div
        v-else-if="tableKey === 'inactiveTeacher'"
        class="table-data overflow-auto start-xs"
      >
        <div
          class="row w-100 no-margin pb3"
          v-for="(teacher, index) in analyticsInactiveTeachers"
          :key="teacher.id"
        >
          <div class="row col-xs-9 no-padding">
            <span class="col-xs-2 w-100 tl" style="padding-right: 0"
              >{{ index + 1 }}.</span
            >
            <span
              class="col-xs-10 no-padding table-data-name clickable ellipsis"
              @click="openUserDetails(teacher)"
            >
              {{ teacher.name }}
            </span>
          </div>
          <div class="col-xs-3 no-padding ellipsis end-xs">
            {{ teacher.rts_count }} RTs
          </div>
        </div>
      </div>
      <div
        v-else-if="tableKey === 'recentTopicsUsed'"
        class="table-data overflow-auto start-xs"
      >
        <div
          class="row w-100 no-margin pb3"
          v-for="topic in analyticsRecentTopicsUsed"
          :key="topic.id"
        >
          <div
            @click="goToUniversePremade(topic.id)"
            class="
              col-xs-12
              no-padding
              table-data-name
              clickable
              ellipsis-topics-used
            "
          >
            {{ topic.title }}
            <i
              class="fas fa-external-link-alt"
              style="font-size: 6px; vertical-align: top"
            ></i>
          </div>
          <div class="mt1 f7">
            <span class="b">Used By: </span>
            <span v-for="(user, index) in topic.users" :key="user.index">
              {{ index + 1 !== topic.users.length ? user + ',&nbsp;' : user }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="table-data overflow-auto start-xs">
        <div
          class="row w-100 no-margin pb3"
          v-for="(teacher, index) in analyticsTopUniversePortfolios"
          :key="teacher.profile_url"
        >
          <div class="row col-xs-8 no-padding">
            <span class="col-xs-2 w-100 tl" style="padding-right: 0"
              >{{ index + 1 }}.</span
            >
            <span
              @click="goToUniversePortfolio(teacher)"
              class="col-xs-10 no-padding table-data-name clickable ellipsis"
            >
              {{ teacher.name }}
              <i
                class="fas fa-external-link-alt"
                style="font-size: 6px; vertical-align: top"
              ></i>
            </span>
          </div>
          <div class="col-xs-4 no-padding ellipsis end-xs">
            {{ teacher.topics_count }} Topics
          </div>
        </div>
      </div>
    </div>
    <user-details-modal
      v-if="openDetailsUserID"
      @close="openDetailsUserID = ''"
      :userId="openDetailsUserID"
      :userSchool="userSchool"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import profileServices from 'services/profile/profileServices';
  import URLconfigs from 'services/apiConfigs';
  import authenticationServices from 'features/authentication/authentication.services';
  import userDetailsModal from 'features/admin/adminPortal/userDetailsModal/userDetailsModal';
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      analyticsMostActiveTeachers: {
        type: Array,
        default() {
          return [];
        },
      },
      analyticsInactiveTeachers: {
        type: Array,
        default() {
          return [];
        },
      },
      analyticsRecentTopicsUsed: {
        type: Array,
        default() {
          return [];
        },
      },
      analyticsTopUniversePortfolios: {
        type: Array,
        default() {
          return [];
        },
      },
      tableKey: {
        type: String,
        default: '',
      },
      tooltip: {
        type: String,
        default: '',
      },
    },
    components: {
      userDetailsModal,
    },
    data() {
      return {
        openDetailsUserID: '',
      };
    },
    computed: {
      ...mapGetters(['getCurrentSchool']),
    },
    methods: {
      openUserDetails(user) {
        this.openDetailsUserID = user.id;
        this.userSchool = this.getCurrentSchool.id;
      },
      goToUniversePortfolio(teacher) {
        if (!teacher.profile_url) {
          profileServices
            .createProfile(teacher.id)
            .then(({ data }) => {
              const profile_url = `${URLconfigs.universeURL}/profiles/${data.profile_url}`;
              authenticationServices.navigateToExternalWithAuth(profile_url);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const profile_url = `${URLconfigs.universeURL}/profiles/${teacher.profile_url}`;
          authenticationServices.navigateToExternalWithAuth(profile_url);
        }
      },
      goToUniversePremade(id) {
        const url = `${URLconfigs.universeURL}/roundtables/${id}`;
        authenticationServices.navigateToExternalWithAuth(url);
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .table-card
    width: 370px
    height: 310px
    padding: 20px
    font-size: 18px
    font-weight: 400
    color: #2C3853
    @media (max-width: 1199px) and (min-width: 500px)
      max-width: 340px
      margin-right: 10px
    @media (max-width: 1425px) and (min-width: 1200px)
      max-width: 300px
    .table-card-title
      color: #323F5F
      font-weight: 600
    .table-data
      height: calc(100% - 35px);
      .table-data-name
        color: #72ccd7
        text-decoration: underline
        a
          color: #72ccd7
          text-decoration: underline
      .ellipsis
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
      .ellipsis-topics-used
        overflow: hidden
        text-overflow: ellipsis
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical

  ::-webkit-scrollbar
    display: block
    width: 10px
    -webkit-appearance: none
</style>



// WEBPACK FOOTER //
// adminPortalAnalyticsTableCard.vue?2a143622